module.exports = __webpack_public_path__ + "img/VH.cbf8476e.png";